module.exports = __webpack_public_path__ + "static/img/preview_close_bt.8875abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview_close_bt.png
// module id = B3Ga
// module chunks = 27